import React from 'react'

const TextInput = React.forwardRef((props, ref) => (
  <label className='banner-label'>
    {props.label}
    <input className='form-control' {...props} ref={ref} />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default TextInput
